const config = {
  Amplify: {
    API: {
      endpoints: [
        {
          name: 'api',
          endpoint: process.env.REACT_APP_API,
        },
      ],
    },
    Auth: {
      region: 'us-west-2',
      userPoolId: 'us-west-2_VobwV36f0',
      userPoolWebClientId: '1vcij2s09ihkde7b1kkha37j63',
      authenticationFlowType: 'USER_PASSWORD_AUTH',
    },
  },
};

export default config;